<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">گزارش دسترسی ها</h1>
          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <b-col cols="12">
                <div
                  class="d-flex flex-column flex-md-row flex-wrap align-items-center"
                >
                  <b-form-group
                    class="d-inline-block w-auto mr-md-2"
                    label="نقش کاربر (انگلیسی)"
                    label-for="roleName"
                  >
                    <b-form-input
                      id="roleName"
                      v-model="actionsListFilter.roleName"
                      class="d-inline-block"
                      placeholder="Student"
                      @keydown.enter="setPageNumberAndGetAccessList"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline-block w-auto mr-md-2"
                    label="نقش کاربر (فارسی)"
                    label-for="roleTitle"
                  >
                    <b-form-input
                      v-model="actionsListFilter.roleTitle"
                      id="roleTitle"
                      placeholder="زبان آموز"
                      @keydown.enter="setPageNumberAndGetAccessList"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline-block w-auto mr-md-2"
                    label="نام کاربر"
                    label-for="userFullname"
                  >
                    <b-form-input
                      v-model="actionsListFilter.userFullname"
                      id="userFullname"
                      placeholder="سامان فتاحی"
                      @keydown.enter="setPageNumberAndGetAccessList"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline-block w-auto mr-md-2"
                    label="شماره همراه کاربر"
                    label-for="userMobile"
                  >
                    <b-form-input
                      v-model="actionsListFilter.userMobile"
                      id="userMobile"
                      placeholder="09370214587"
                      @keydown.enter="setPageNumberAndGetAccessList"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline-block w-auto mr-md-2"
                    label="آدرس دسترسی"
                    label-for="accessName"
                  >
                    <b-form-input
                      v-model="actionsListFilter.accessName"
                      id="accessName"
                      placeholder="Users/GetByToken"
                      @keydown.enter="setPageNumberAndGetAccessList"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline-block w-auto mr-md-2"
                    label="نام فارسی دسترسی"
                    label-for="accessTitle"
                  >
                    <b-form-input
                      v-model="actionsListFilter.accessTitle"
                      id="accessTitle"
                      placeholder="مشاهده اطلاعات کاربر لاگین شده"
                      @keydown.enter="setPageNumberAndGetAccessList"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline-block w-auto mr-md-2"
                    label="تاریخ ایجاد"
                    label-for="createDate"
                  >
                    <b-input-group class="input-group-merge w-auto mr-md-2">
                      <b-form-input
                        :value="createJalaliDate(actionsListFilter.createDate)"
                        id="createDate"
                        class="createDate"
                        placeholder="تاریخ ایجاد"
                      ></b-form-input>
                      <b-input-group-append is-text>
                        <template v-if="actionsListFilter.createDate">
                          <feather-icon
                            @click="clearDateFilter"
                            class="cursor-pointer"
                            icon="XIcon"
                            size="18"
                          />
                        </template>
                        <template v-else>
                          <feather-icon
                            class="cursor-pointer"
                            icon="ClockIcon"
                            size="18"
                          />
                        </template>
                        <date-picker
                          v-model="actionsListFilter.createDate"
                          customInput=".createDate"
                          :jumpMinute="10"
                          :roundMinute="true"
                          format="YYYY-MM-DD"
                          display-format="jYYYY-jMM-jDD"
                          type="date"
                        ></date-picker>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-button
                    type="button"
                    variant="primary"
                    @click="setPageNumberAndGetAccessList"
                    >اعمال</b-button
                  >
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-table
                  ref="refUserListTable"
                  class="position-relative mt-3"
                  :items="actionsList"
                  responsive
                  :fields="myTableColumns"
                  primary-key="id"
                  show-empty
                  bordered
                  striped
                  empty-text="موردی موجود نیست!"
                >
                  <template #cell(userFullname)="data">
                    <b-link :to="`/users/${data.item.userId}`">
                      {{ data.item.userFullname }}
                    </b-link>
                  </template>
                  <template #cell(createDate)="data">
                    <span style="white-space: nowrap">
                      {{
                        new Date(data.item.createDate).toLocaleDateString(
                          "fa-IR"
                        )
                      }}
                      -
                      {{
                        new Date(data.item.createDate).toLocaleTimeString(
                          "fa-IR",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )
                      }}
                    </span>
                  </template>
                  <template #cell(actions)="data">
                    <feather-icon
                      v-b-modal.modal-access-confirm
                      @click="getConfirmationForAccess(data.item)"
                      icon="CheckIcon"
                      size="22"
                      class="text-success cursor-pointer"
                    />
                  </template>
                </b-table>
              </b-col>

              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
              >
                <b-pagination
                  v-model="actionsListFilter.pageNumber"
                  :total-rows="totalCount"
                  :per-page="actionsListFilter.count"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      style="transform: rotate(180deg)"
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <!-- Add Access Confirmation Modal Start -->
    <b-modal
      title="دادن یک نقش به کاربر"
      id="modal-access-confirm"
      centered
      ok-title="تایید"
      cancel-title="بستن"
      @ok="confirmRoleAccessAction"
    >
      <b-container fluid>
        <b-form-row>
          <b-col cols="12">
            <p v-if="tempAction">
              آیا از دادن دسترسی
              <span style="font-weight: bold" class="text-danger">
                {{ tempAction.accessTitle }}
              </span>
              به کاربر
              <span style="font-weight: bold" class="text-primary">
                {{ tempAction.userFullname }}
              </span>
              اطمینان دارید؟
            </p>
          </b-col>
        </b-form-row>
      </b-container>
    </b-modal>

    <!-- Add Access Confirmation Modal End -->
  </b-overlay>
</template>
<script>
export default {
  watch: {
    pageNumber: {
      handler(val) {
        this.getAccessLogList();
      },
    },
  },
  mounted() {
    this.getAccessLogList();
  },
  data() {
    return {
      isLoading: false,
      actionsList: null,
      totalCount: null,
      actionsListFilter: {
        pageNumber: 1,
        count: 10,
        roleName: null,
        roleTitle: null,
        userFullname: null,
        userMobile: null,
        accessTitle: null,
        accessName: null,
        createDate: null,
      },
      myTableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "userFullname",
          label: "نام کاربر",
        },
        {
          key: "userMobile",
          label: "شماره همراه کاربر",
        },
        {
          key: "roleTitle",
          label: "نام فارسی نقش",
        },
        {
          key: "roleName",
          label: "نام انگلیسی نقش",
        },
        {
          key: "accessTitle",
          label: "عنوان عملیات",
        },
        {
          key: "accessName",
          label: "آدرس عملیات",
        },
        {
          key: "accessName",
          label: "آدرس عملیات",
        },
        {
          key: "createDate",
          label: "تاریخ ایجاد",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      tempAction: null,
    };
  },
  methods: {
    async confirmRoleAccessAction() {
      try {
        this.isLoading = true;
        let _this = this;
        let confirmAccessControlAction = new ConfirmAccessControlAction(_this);
        confirmAccessControlAction.setRequestParam({ id: _this.tempAction.id });
        await confirmAccessControlAction.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "دسترسی با موفقیت اضافه شد.",
              },
            });
            _this.tempAction = null;
            _this.getAccessLogList();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setPageNumberAndGetAccessList() {
      this.actionsListFilter.pageNumber = 1;
      this.getAccessLogList();
    },
    getConfirmationForAccess(item) {
      this.tempAction = JSON.parse(JSON.stringify(item));
    },
    clearDateFilter() {
      this.actionsListFilter.createDate = null;
    },
    createJalaliDate(date) {
      if (date) {
        const myCustomDate = new Date(date).toLocaleDateString("fa-IR");
        const myCustomTime = new Date(date).toLocaleTimeString("fa-IR");
        return `${myCustomDate} - ${myCustomTime}`;
      } else {
        return null;
      }
    },
    async getAccessLogList() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAccessControlActionList = new GetAccessControlActionList(_this);
        getAccessControlActionList.setRequestParamDataObj(
          _this.actionsListFilter
        );
        await getAccessControlActionList.fetch((res) => {
          _this.actionsList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.actionsListFilter.pageNumber;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BModal,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroupAppend,
    BInputGroup,
    BFormRow,
    BContainer,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BFormRow,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroupAppend,
  BInputGroup,
  BContainer,
} from "bootstrap-vue";
import {
  GetAccessControlActionList,
  ConfirmAccessControlAction,
} from "@/libs/Api/AccessCtrlActionRequire";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
